import type { Layout } from "@coral-xyz/borsh";
import { bool, publicKey, struct, u8, u32, u64, u128 } from "@coral-xyz/borsh";
import type { PublicKey } from "@solana/web3.js";
import type BN from "bn.js";

export type LendingReserveLayout = {
  version: number;
  lastUpdateSlot: {
    slot: BN;
    stale: boolean;
  };
  lendingMarket: PublicKey;
  borrowAuthorizer: PublicKey;
  liquidity: {
    mintPubKey: PublicKey;
    mintDecimals: number;
    supplyPubKey: PublicKey;
    feeReceiver: PublicKey;
    oraclePubKey: PublicKey;
    availableAmount: BN;
    borrowedAmountWads: BN;
    cumulativeBorrowRate: BN;
    marketPrice: BN;
    platformAmountWads: BN;
    platformFees: number;
  };
};

export const LENDING_RESERVE_LAYOUT: Layout<LendingReserveLayout> = struct([
  u8("version"),
  struct([u64("slot"), bool("stale")], "lastUpdateSlot"),

  publicKey("lendingMarket"),
  publicKey("borrowAuthorizer"),

  struct(
    [
      publicKey("mintPubKey"),
      u8("mintDecimals"),
      publicKey("supplyPubKey"),
      publicKey("feeReceiver"),
      publicKey("oraclePubKey"),
      u64("availableAmount"),
      u128("borrowedAmountWads"),
      u128("cumulativeBorrowRate"),
      u128("marketPrice"),
      u128("platformAmountWads"),

      u8("platformFees"),
    ],
    "liquidity",
  ),
]);

export type MintInfoLayout = {
  mintAuthorityOption: number;
  mintAuthority: PublicKey;
  supply: BN;
  decimals: number;
  initialized: boolean;
  freezeAuthorityOption: number;
  freezeAuthority: PublicKey;
};

export const MINT_INFO_LAYOUT = struct<MintInfoLayout>([
  u32("mintAuthorityOption"),
  publicKey("mintAuthority"),
  u64("supply"),
  u8("decimals"),
  bool("initialized"),
  u32("freezeAuthorityOption"),
  publicKey("freezeAuthority"),
]);
